import React, { FC, useEffect, useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { CgProfile } from 'react-icons/cg';
import Modal from 'react-modal';

import { useWindowSize } from '../../../hooks';
import { getOneCase } from '../../../services/cases/getCaseById';
import { getUserAvatar } from '../../../services/identity/getUserAvatar';
import { UserProfile } from '../../../services/identity/types/UserProfile';
import { customStylesDashboard } from '../../../Utils/customStyles';
import { displayErrorDetails } from '../../../Utils/displayError';
import styles from './styles.module.scss';

interface ProfileCardModalProps {
  isOpen: boolean;
  toggleModal: (bool: boolean) => void;
  collectorIdentity: UserProfile | null;
  caseId?: number;
}

const CollectorProfileCardModal: FC<ProfileCardModalProps> = ({
  isOpen,
  toggleModal,
  collectorIdentity,
  caseId = 0,
}) => {
  const isMobile = useWindowSize().width < 992;
  const mobileCustomStylesDashboard = {
    ...customStylesDashboard,
    overlay: {
      ...customStylesDashboard.overlay,
      overflowY: 'scroll',
    },
    content: {
      ...customStylesDashboard.content,
      transform: 'translate(-50%, -50%)',
      width: '90%',
    },
  };

  const [collectorIdentityFromCase, setCollectorIdentity] = useState<UserProfile | null>(null);

  const initIdentity = async (): Promise<void> => {
    try {
      if (caseId && collectorIdentity?.basic_info === undefined) {
        const thisCase = await getOneCase(caseId);
        if (thisCase) {
          setCollectorIdentity(thisCase.collector);
        }
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    initIdentity();
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else if (document.body.classList.contains('modal-open') && !isOpen) {
      document.body.classList.remove('modal-open');
    }
  }, [isOpen]);
  const closeModal = (): void => {
    toggleModal(false);
  };

  const [avatarIcon, setAvatarIcon] = useState(false);
  const handleAvatarError = (): void => {
    setAvatarIcon(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboard}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.profilCardCC}>
        <button
          type="button"
          className={styles.modalClose}
          data-micromodal-close=""
          onClick={closeModal}
          aria-label="Close modal"
        >
          <AiOutlineCloseCircle className={styles.icon} />
        </button>
        <div className={styles.titleContainer}>
          <div className={styles.profileContainer}>
            <div className={styles.caImageContainer}>
              {!avatarIcon ? (
                <img
                  alt="Avatar"
                  onError={handleAvatarError}
                  className={styles.providerImage}
                  src={getUserAvatar(collectorIdentity?.id || 0)}
                />
              ) : (
                <CgProfile />
              )}
            </div>
            <div className={styles.textContainer}>
              <div className={styles.title}>{collectorIdentity?.full_name}</div>
              <div className={styles.details}>
                <div className={styles.gender}>
                  {collectorIdentity?.basic_info !== undefined
                    ? collectorIdentity?.basic_info?.gender
                    : collectorIdentityFromCase?.basic_info?.gender}{' '}
                  -{' '}
                  {collectorIdentity?.basic_info !== undefined
                    ? collectorIdentity?.basic_info?.pronouns
                    : collectorIdentityFromCase?.basic_info?.pronouns}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.profileCardBody}>
          <div className={styles.language}>
            <div className={styles.languages}>
              <div className={styles.title}>Language</div>
              <div className={styles.tags}>
                {collectorIdentity?.basic_info !== undefined
                  ? collectorIdentity?.basic_info?.languages?.map((language) => (
                      <div className={styles.tag} key={typeof language !== 'string' ? language.name : language}>
                        <div className={styles.label}>{typeof language !== 'string' && language.name}</div>
                      </div>
                    ))
                  : collectorIdentityFromCase?.basic_info?.languages?.map((language) => (
                      <div className={styles.tag} key={typeof language !== 'string' ? language.name : language}>
                        <div className={styles.label}>{typeof language !== 'string' && language.name}</div>
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default CollectorProfileCardModal;
